import axios from 'axios';
import moment from 'moment';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { PureComponent } from 'react';
import { Alert, OverlayTrigger, Popover } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { connect } from 'react-redux';
import {
  addFlag,
  setListeningToDocument,
  setPlaybackPlaylists,
  setPlayingDocumentId,
  updateDocument,
  updateDocumentProgress
} from '../../../redux/actions/app-actions';
import {
  createFlagFromPlayer,
  fetchAllFlagsByDocumentUrl
} from '../../../redux/actions/pdf-actions';
import {
  resetProgress,
  sameProgress,
  setAllDocuments,
  setDisableSkipAheadButton,
  setDisableSkipBackButton,
  setFeedUrl,
  setFromSkip,
  setFullSerialDocuments,
  setIsPaused,
  setNewDocumentInLast5,
  setFlagAdded,
  setPlayerDocument,
  setPlayerFlag,
  setSeason,
  setShowSkipButton,
  setStoreProgress
} from '../../../redux/actions/player-actions';
import { default as config } from '../../../constants/constants';
import { firebase } from '../../../firebase';
import highlightButtonSmallInactive from '../../../images/player/button-small-inactive.png';
import highlightButtonSmallInactive2x from '../../../images/player/button-small-inactive@2x.png';
import highlightButtonSmallInactive3x from '../../../images/player/button-small-inactive@3x.png';
import highlightButtonSmallPressed from '../../../images/player/button-small-pressed.png';
import highlightButtonSmallPressed2x from '../../../images/player/button-small-pressed@2x.png';
import highlightButtonSmallPressed3x from '../../../images/player/button-small-pressed@3x.png';
import highlightButtonSmall from '../../../images/player/button-small.png';
import highlightButtonSmall2x from '../../../images/player/button-small@2x.png';
import highlightButtonSmall3x from '../../../images/player/button-small@3x.png';
import highlightButton from '../../../images/player/flag-button-active.png';
import highlightButton2x from '../../../images/player/flag-button-active@2x.png';
import highlightButton3x from '../../../images/player/flag-button-active@3x.png';
import highlightButtonPressed from '../../../images/player/flag-button-highlight.png';
import highlightButtonPressed2x from '../../../images/player/flag-button-highlight@2x.png';
import highlightButtonPressed3x from '../../../images/player/flag-button-highlight@3x.png';
import highlightButtonInactive from '../../../images/player/flag-button-inactive.png';
import highlightButtonInactive2x from '../../../images/player/flag-button-inactive@2x.png';
import highlightButtonInactive3x from '../../../images/player/flag-button-inactive@3x.png';
import { ReactComponent as IconBack15 } from '../../../images/player/icon-back-15.svg';
import { ReactComponent as IconBackward } from '../../../images/player/icon-backward.svg';
import { ReactComponent as IconForward15 } from '../../../images/player/icon-forward-15.svg';
import { ReactComponent as IconForward } from '../../../images/player/icon-forward.svg';
import { ReactComponent as VolumeButtonSvg } from '../../../images/player/icon-speaker.svg';

import FlagIcon from '@material-ui/icons/Flag';

import {
  getDefaultSrc,
  getImageSrcSetForCurrentState
} from '../../../utils/mediaPlayerUtils';
import { convertSecondsToTime, getProgress } from '../../../utils/utils';
import { updatedocumentAPI } from '../../dashboard/apis/document';
import ModalTag from '../../dashboard/components/ModalTag';
import eventBus from '../../../components/EventBus';
// import Capture from './CaptureModal';
import CaptureWithJudgementModal from './CaptureWithJudgementModal';

require('../styles/media-player.css');

class MediaPlayer extends PureComponent {
  static defaultProps = {
    onPlay: () => {},
    onPause: () => {},
    onProgress: () => {}
  };

  constructor(props) {
    super(props);

    this.state = {
      playbackRate: this.setPlaybackRate(),
      modalTag: false,
      track: 0,
      play: false,
      showAlert: false,
      message: null,
      error: false,
      cantPlay: false,
      transcribe: this.setTranscribeOption(),
      showSpeedControl: false,
      showAlertAudio: false,
      showSelect: true,
      openCapture: false,
      displayVolume: false,
      volume: 0.5,
      muted: false,
      progress: 0,
      playButtonState: 'inactive',
      isSmallScreen: window.innerWidth < 1092,
      captureButtonPressed: false,
      currentIndex: 0,
      currentDocument: ''
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  ref = (player) => (this.player = player);

  componentDidMount() {

    if (
      this.props.playerDocument &&
      this.props.playerDocument.episode &&
      this.props.playerDocument.episode.url === ''
    ) {
      this.handleError();
    } else {
      if (this.player) {
        if (this.player.getCurrentTime() == this.player.getDuration()) {
          if (this.props.resetProgress) {
            this.player.seekTo(-1);
            this.props.dispatch(resetProgress(false));
          } else {
            this.setState({ play: false });
          }
        }
      }
    }
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillMount() {
    this.setState({ progress: this.props.playerDocument?.progress });
  }

  componentWillUnmount() {
    clearTimeout(this.interval);
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps) {
    const {
      allSeasons,
      playerDocument,
      fromPlaylistTab,
      playbackPlaylist,
      fullDocuments,
      feedUrl,
      isPaused
    } = this.props;
    const documents = fromPlaylistTab ? playbackPlaylist : fullDocuments;
    const currentDocumentSeason = playerDocument?.season;

    const index = documents.findIndex((epi) =>
      fromPlaylistTab
        ? epi.document.id === playerDocument?.id
        : epi.uuid === playerDocument?.uuid
    );

    if (feedUrl !== prevProps.feedUrl) {
      this.props.dispatch(setDisableSkipBackButton(true));
      this.props.dispatch(setDisableSkipAheadButton(true));
    }

    if (documents.length === 0) {
      this.props.dispatch(setDisableSkipBackButton(true));
      this.props.dispatch(setDisableSkipAheadButton(true));
    }

    // Hide skip buttons if there are no full documents
    if (documents.length === 0) {
      this.props.dispatch(setShowSkipButton(false));
    } else {
      this.props.dispatch(setShowSkipButton(true));
    }

    if (prevProps.playerDocument !== playerDocument) {
      this.setState({ currentDocument: playerDocument });
    }

    if (index !== -1) {
      this.setState({ currentIndex: index });
    }

    if (documents.length > 0) {
      // Check if the current document is the last document
      if (index + 1 >= documents.length) {
        if (
          currentDocumentSeason !== config.unknownSeason &&
          currentDocumentSeason !== allSeasons.length
        ) {
          if (!fromPlaylistTab) {
            this.props.dispatch(setDisableSkipAheadButton(false));
          } else {
            this.props.dispatch(setDisableSkipAheadButton(true));
          }
        } else {
          this.props.dispatch(setDisableSkipAheadButton(true));
        }
      } else {
        this.props.dispatch(setDisableSkipAheadButton(false));
      }

      // Check if the current document is the first document
      if (index === 0) {
        this.props.dispatch(setDisableSkipBackButton(true));
      } else {
        this.props.dispatch(setDisableSkipBackButton(false));
      }
    }

    if (prevProps.playerDocument !== playerDocument) {
      const progress = this.state.progress;
      this.setState({ playbackRate: this.setPlaybackRate(), cantPlay: false });

      if (
        prevProps.playerDocument?.id &&
        (this.props.resource === 'documents' ||
          this.props.resource === 'documentsSummary')
      ) {
        this.storePlayerProgress(prevProps.playerDocument.id, progress);
      }
    }

    if (this.props.sameProgress) {
      this.player.seekTo(playerDocument.progress);
      this.props.dispatch(sameProgress(false));
    }

    if (
      playerDocument?.progress &&
      prevProps.playerDocument?.progress !== playerDocument.progress
    ) {
      if (!this.props.onPlaylist) {
        this.player.seekTo(playerDocument.progress);
      }
    }

    if (playerDocument?.document?.url === '') {
      this.handleError();
    }

    if (prevProps.isPaused !== isPaused && isPaused) {
      this.handlePause();
    }
  }

  storePlayerProgress = async (documentId, progress) => {
    try {
      const token = await firebase.auth.currentUser.getIdToken();
      if (token) {
        const response = await updateDocumentAPI(token, {
          id: documentId,
          progress
        });
        const data = response.data;

        // Update allDocuments variable that used in Documents tab
        const documents = this.props.allDocuments.map((existingDocument) => {
          const { id: documentId, progress } = data;

          if (documentId?.toString() === existingDocument?.id?.toString()) {
            return { ...existingDocument, progress };
          }

          if (
            documentId?.toString() ===
            existingDocument?.summaryDocument?.id?.toString()
          ) {
            return {
              ...existingDocument,
              summaryDocument: { ...existingDocument.summaryDocument, progress }
            };
          }

          return existingDocument;
        });

        this.props.dispatch(setAllDocuments(documents));
      }
    } catch (error) {
      this.setErrorHandler();
    }
  };

  // update windows dimensions according to screen viewport
  updateWindowDimensions() {
    this.setState({ isSmallScreen: window.innerWidth < 1094 });
  }

  handleError = () => {
    this.setState({
      showAlertAudio: true,
      error: true,
      cantPlay: true,
      play: false,
      message: 'Audio fragment is not available for playback'
    });
  };

  showAlertFunction = (showAlert, error, message) => {
    this.setState({ showAlert: showAlert, error: error, message: message });
    this.updateFlagsTable(error);
  };

  onSliderChange = (value) => {
    this.setState({ playbackRate: value });
    localStorage.setItem('userPlaybackRate', value);
  };

  forward = () => {
    this.props.dispatch(setDisableSkipBackButton(false));
    let allSeasons = this.props.allSeasons;
    let currentIndex = this.state.currentIndex;
    let fromPlaylist = this.props.fromPlaylistTab;
    let currentDocument = this.props.playerDocument;
    let documents = fromPlaylist
      ? this.props.playbackPlaylist
      : this.props.fullDocuments;

    let indexForUnknownSeason = allSeasons.findIndex((s) => s === 'Unknown');
    let completed = 0;

    //if type of currentDocument.id is number
    if (!fromPlaylist) {
      let currentDocumentSeason = currentDocument.season;

      if (currentIndex === documents.length - 1) {
        // Go to next season if it is last document of a season
        if (
          currentDocumentSeason !== config.unknownSeason &&
          currentDocumentSeason !== allSeasons.length
        ) {
          this.loadSeason(currentDocumentSeason + 1);
        }
      } else {
        let nextDocument = documents[currentIndex + 1];
        let id = nextDocument.id;
        nextDocument.duration = this.player.getDuration();
        //disable button if it is last document of last season(Unknown season its not include)
        if (
          (indexForUnknownSeason !== -1 &&
            currentDocumentSeason === allSeasons.length - 1) ||
          currentDocumentSeason === allSeasons.length
        ) {
          if (currentIndex === documents.length - 2) {
            this.props.dispatch(setDisableSkipAheadButton(true));
          }
        }
        //not listened document
        if (typeof id === 'string' && id.startsWith('0')) {
          this.saveNewDocument(
            nextDocument,
            currentDocumentSeason,
            currentIndex,
            documents,
            allSeasons,
            'next'
          );
        } else {
          this.props.dispatch(setPlayingDocumentId(nextDocument.id));
          this.props.dispatch(setListeningToDocument(true));
          this.props.dispatch(setPlayerDocument(nextDocument));
          this.props.dispatch(setIsPaused(false));
          this.props.dispatch(setFeedUrl(nextDocument.feedUrl));
          this.props.dispatch(setStoreProgress(true));
          completed = getProgress(
            nextDocument.progress,
            parseInt(this.player.getDuration(), 10)
          );
          if (completed >= 100) {
            this.props.dispatch(resetProgress(true));
          } else {
            this.props.dispatch(resetProgress(false));
          }

          this.player.seekTo(nextDocument.progress);
          this.setState({ progress: nextDocument.progress });
        }
      }
    } else {
      if (currentIndex === documents.length - 2) {
        this.props.dispatch(setDisableSkipAheadButton(true));
      }
      let nextDocument = documents[currentIndex + 1].document;
      nextDocument.duration = this.player.getDuration();
      this.props.dispatch(setPlayingDocumentId(nextDocument.id));
      this.props.dispatch(setListeningToDocument(true));
      this.props.dispatch(setPlayerDocument(nextDocument));
      this.props.dispatch(setIsPaused(false));
      this.props.dispatch(setFeedUrl(nextDocument.feedUrl));
      this.props.dispatch(setStoreProgress(true));
      completed = getProgress(
        nextDocument.progress,
        parseInt(this.player.getDuration(), 10)
      );
      if (completed >= 100) {
        this.props.dispatch(resetProgress(true));
      } else {
        this.props.dispatch(resetProgress(false));
      }
      this.player.seekTo(nextDocument.progress);
      this.setState({ progress: nextDocument.progress });
    }
  };

  backward = () => {
    this.props.dispatch(setDisableSkipAheadButton(false));
    let allSeasons = this.props.allSeasons;
    let fromPlaylist = this.props.fromPlaylistTab;
    let currentIndex = this.state.currentIndex;
    let currentDocument = this.props.playerDocument;
    let documents = fromPlaylist
      ? this.props.playbackPlaylist
      : this.props.fullDocuments;

    let completed = 0;
    //if type of currentDocument.id is number
    if (!fromPlaylist) {
      if (currentIndex === -1) {
        currentIndex = documents.findIndex(
          (epi) => parseInt(epi.id, 10) === currentDocument.id
        );
        currentDocument = documents.find(
          (epi) => parseInt(epi.id, 10) === currentDocument.id
        );
      }
      let currentDocumentSeason = currentDocument.season;
      if (currentIndex === 0) {
        if (currentDocumentSeason !== 1) {
          this.loadSeason(currentDocumentSeason - 1);
        }
      } else {
        let previousDocument = documents[currentIndex - 1];
        previousDocument.duration = this.player.getDuration();
        //disable button if it is first document of first season
        if (currentDocumentSeason === 1) {
          if (currentIndex === 1) {
            this.props.dispatch(setDisableSkipBackButton(true));
          }
        }
        if (typeof id === 'string' && id.startsWith('0')) {
          this.saveNewDocument(
            previousDocument,
            currentDocumentSeason,
            currentIndex,
            documents,
            allSeasons,
            'previous'
          );
        } else {
          this.props.dispatch(setPlayingDocumentId(previousDocument.id));
          this.props.dispatch(setListeningToDocument(true));
          this.props.dispatch(setPlayerDocument(previousDocument));
          this.props.dispatch(setIsPaused(false));
          this.props.dispatch(setFeedUrl(previousDocument.feedUrl));
          this.props.dispatch(setStoreProgress(true));
          completed = getProgress(
            previousDocument.progress,
            parseInt(this.player.getDuration(), 10)
          );
          if (completed >= 100) {
            this.props.dispatch(resetProgress(true));
          } else {
            this.props.dispatch(resetProgress(false));
          }

          this.player.seekTo(previousDocument.progress);
          this.setState({ progress: previousDocument.progress });
        }
      }
    } else {
      let previousDocument = documents[currentIndex - 1].document;
      previousDocument.duration = this.player.getDuration();
      //disable button if it is first document
      if (currentIndex === 1) {
        this.props.dispatch(setDisableSkipBackButton(true));
      }
      this.props.dispatch(setPlayingDocumentId(previousDocument.id));
      this.props.dispatch(setListeningToDocument(true));
      this.props.dispatch(setPlayerDocument(previousDocument));
      this.props.dispatch(setIsPaused(false));
      this.props.dispatch(setFeedUrl(previousDocument.feedUrl));
      this.props.dispatch(setStoreProgress(true));
      completed = getProgress(
        previousDocument.progress,
        parseInt(this.player.getDuration(), 10)
      );
      if (completed >= 100) {
        this.props.dispatch(resetProgress(true));
      } else {
        this.props.dispatch(resetProgress(false));
      }
      this.player.seekTo(previousDocument.progress);
      this.setState({ progress: previousDocument.progress });
    }
  };

  loadSeason = (season) => {
    this.props.dispatch(setFromSkip(true));
    this.props.dispatch(setSeason(season));

    eventBus.dispatch('onLoadSeason', { season });
  };

  saveNewDocument = (document, season, index, documents, allSeasons, opt) => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        document.timestampListened = moment().valueOf();
        const options = {
          method: 'POST',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/documents`,
          data: { ...document, id: null }
        };

        if (document.url !== null && document.url !== '') {
          axios(options)
            .then((result) => {
              document.id = result.data.id;
              if (opt === 'next') {
                if (
                  season === config.unknownSeason ||
                  season === allSeasons.length
                ) {
                  if (index === documents.length - 2) {
                    this.props.dispatch(setDisableSkipAheadButton(true));
                  }
                }
              } else {
                if (season === 1) {
                  if (index === 1) {
                    this.props.dispatch(setDisableSkipBackButton(true));
                  }
                }
              }
              this.props.dispatch(setPlayingDocumentId(result.data.id));
              this.props.dispatch(setListeningToDocument(true));
              this.props.dispatch(setPlayerDocument(document));
              this.props.dispatch(setIsPaused(false));
              this.props.dispatch(setFeedUrl(document.feedUrl));
              this.props.dispatch(setStoreProgress(true));
              this.props.dispatch(setNewDocumentInLast5(true));

              this.player.seekTo(this.props.playerDocument.progress);
            })
            .catch(() => {
              this.setErrorHandler();
            });
        }
      });
    }
  };

  stepBackward = (step) => {
    if (this.player) {
      const currentTime = parseInt(this.player.getCurrentTime(), 10);
      this.player.seekTo(currentTime - step);
      this.setState({ progress: currentTime - step });
    }
  };

  stepForward = (step) => {
    if (this.player) {
      const currentTime = parseInt(this.player.getCurrentTime(), 10);
      this.player.seekTo(currentTime + step);
      this.setState({ progress: currentTime + step });
    }
  };

  handleStart = () => {
    this.props.dispatch(setPlayerFlag(''));

    if (
      this.props.playerDocument.progress &&
      this.props.playerDocument.episode.id === undefined
    ) {
      const values = {
        id: this.props.playerDocument.id,
        duration: this.player.getDuration()
      };
      if (values.id !== null) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          this.props.dispatch(updateDocument(token, values));
          this.props.dispatch(setPlayerDocument(this.props.playerDocument));
        });
      }
    }

    if (
      (this.props.resource === 'notes' ||
        this.props.resource === 'flags' ||
        this.props.resource === 'notifications') &&
      this.props.playerDocument.progress === undefined
    ) {
      this.player.seekTo(this.props.playerDocument.trackPosition);
    } else {
      this.props.resetProgress
        ? this.player.seekTo(-1)
        : this.player.seekTo(this.props.playerDocument.progress);
      this.props.dispatch(resetProgress(false));
    }
  };

  handlePlay = () => {
    if (
      this.props.playerDocument?.document &&
      this.props.playerDocument.document.id === undefined
    ) {
      let completed = getProgress(
        this.props.playerDocument.progress,
        parseInt(this.player.getDuration(), 10)
      );
      if (completed >= 100) {
        this.props.dispatch(resetProgress(true));
      } else {
        this.props.dispatch(resetProgress(false));
      }
      const values = {
        id: this.props.playerDocument.id,
        duration: this.player.getDuration()
      };
      let id = values.id;
      let isNewDocument = typeof id === 'string' && id.startsWith('0');
      if (values.id !== null && !isNewDocument) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          this.props.dispatch(updateDocument(token, values));
          this.props.dispatch(setPlayerDocument(this.props.playerDocument));
        });
      } else if (isNewDocument) {
        let document = this.props.playerDocument;
        document.duration = this.player.getDuration();
        firebase.auth.currentUser.getIdToken().then((token) => {
          this.props.dispatch(updateDocument(token, { ...document, id: null }));
          this.props.dispatch(setPlayerDocument(this.props.playerDocument));
        });
      }
    }

    this.props.dispatch(setPlayingDocumentId(this.props.playerDocument.id));
    this.props.dispatch(setListeningToDocument(true));
    this.props.dispatch(setIsPaused(false));
    this.setState({ play: true, playButtonState: 'active' });
  };

  handlePause = () => {
    this.setState({ play: false, playButtonState: 'active' }, () =>
      this.saveProgress(false)
    );
  };

  onProgress = (document) => {
    if (
      this.props.resource === 'flags' ||
      this.props.resource === 'notifications'
    ) {
      if (this.props.playerDocument.progress) {
        const progress = parseInt(document.playedSeconds, 10);
        this.setState({ progress });
        let epi = this.props.playerDocument;
        epi.progress = progress;
        if (progress % 60 === 0) {
          this.saveProgress();
        } else {
          this.props.dispatch(
            updateDocumentProgress(this.props.playerDocument, progress)
          );
        }
      }
    } else {
      let row = this.props.playerDocument;
      let id = row.id;
      const progress = parseInt(document.playedSeconds, 10);
      if (progress % 60 === 0) {
        this.saveProgress();
      } else if (id !== null) {
        this.props.dispatch(
          updateDocumentProgress(this.props.playerDocument, progress)
        );
        this.setState({ progress });
      } else if (id === null || id.toString().startsWith('0')) {
        // Case of full playback from documents tab when listening to an document that hasn't been saved
        if (firebase.auth.currentUser) {
          firebase.auth.currentUser.getIdToken().then((token) => {
            row.timestampListened = moment().valueOf();
            const options = {
              method: 'POST',
              headers: { 'X-Firebase-Auth': token },
              url: `${config.serverURL}/documents`,
              data: { ...row, id: null }
            };

            if (row.url !== null && row.url !== '') {
              axios(options)
                .then((result) => {
                  let epi = result.data;
                  this.setState({ progress: epi.progress });
                  this.props.dispatch(
                    setPlayerDocument(this.props.playerDocument)
                  );
                  this.props.dispatch(setNewDocumentInLast5(true));
                })
                .catch(() => {
                  this.setErrorHandler();
                });
            }
          });
        }
      } else {
        // Default case: update progress
        this.setState({ progress });
        this.props.dispatch(
          updateDocumentProgress(this.props.playerDocument, progress)
        );
      }

      eventBus.dispatch('onProgress', { document: document });
    }
    this.setState({ currentTime: this.player.getCurrentTime() });
  };

  onEnded = () => {
    const document = this.props.playerDocument;
    document.duration = this.player.getDuration();
    setPlayerDocument(document);
    this.setState({ play: false });
  };

  onSeek = () => {
    this.saveProgress();
  };

  saveProgress = (isPlayed) => {
    if (isPlayed || isPlayed === undefined) {
      this.props.dispatch(setIsPaused(false));
    } else {
      this.props.dispatch(setIsPaused(true));
      this.props.dispatch(setListeningToDocument(false));
    }

    if (this.player) {
      if (
        this.props.resource === 'flags' ||
        this.props.resource === 'notifications'
      ) {
        if (this.props.playerDocument.progress && this.props.setStoreProgress) {
          const progress = this.player.getCurrentTime();
          this.setState({ progress });
          const values = {
            id: this.props.playerDocument.document.id,
            progress
          };

          if (firebase.auth.currentUser) {
            firebase.auth.currentUser.getIdToken().then((token) => {
              this.props.dispatch(updateDocument(token, values));
              this.props.dispatch(setPlayerDocument(this.props.playerDocument));
            });
          }
        }
      } else {
        const progress = this.player.getCurrentTime();
        let values = {};
        if (this.props.playerDocument) {
          values = {
            id: this.props.playerDocument.id,
            progress
          };

          let id = values.id;
          let row = this.props.playerDocument;
          //case of play serial podcasts
          if (id === null || id.toString().startsWith('0')) {
            row.timestampListened = moment().valueOf();
            firebase.auth.currentUser.getIdToken().then((token) => {
              const options = {
                method: 'POST',
                headers: { 'X-Firebase-Auth': token },
                url: `${config.serverURL}/documents`,
                data: { ...row, id: null }
              };
              if (row.url !== null && row.url !== '') {
                axios(options)
                  .then((result) => {
                    let epi = result.data;
                    this.setState({ progress: epi.progress });
                    this.props.dispatch(
                      setPlayerDocument(this.props.playerDocument)
                    );
                    this.props.dispatch(setNewDocumentInLast5(true));
                  })
                  .catch(() => {
                    this.setErrorHandler();
                  });
              }
            });
          } else {
            if (firebase.auth.currentUser) {
              firebase.auth.currentUser.getIdToken().then((token) => {
                if (values.id !== null && progress !== null) {
                  this.setState({ progress });
                  this.props.dispatch(updateDocument(token, values));
                  if (this.props.playerDocument !== '') {
                    this.props.playerDocument.progress = progress;

                    if (this.props.playerDocument.episode) {
                      this.props.playerDocument.episode.progress = progress;
                    }
                    
                    this.props.playerDocument.showThumbs = row.showThumbs;
                  }
                  this.props.dispatch(
                    setPlayerDocument(this.props.playerDocument)
                  );
                }
              });
            }
          }
          if (this.props.resource === 'playlists') {
            let documents = this.props.playbackPlaylist;
            documents.map((obj) => {
              if (obj.document.id === id) {
                obj.document.progress = progress;
              }
            });
            this.props.dispatch(setPlaybackPlaylists({ documents: documents }));
          } else {
            let fullDocuments = this.props.fullDocuments;
            fullDocuments.map((obj) => {
              if (obj.id === id) {
                obj.progress = progress;
              } else if (obj.id === null) {
                obj.id = id;
                obj.progress = progress;
              } else if (
                obj.episodeName === row.episodeName &&
                obj.releaseDate === row.releaseDate
              ) {
                obj.id = id;
                obj.progress = progress;
              }
              this.props.dispatch(setFullSerialDocuments(fullDocuments));
            });
            let allDocuments = this.props.allDocuments;
            allDocuments.map((obj) => {
              if (obj.id === id) {
                obj.progress = progress;
              } else if (obj.id === null) {
                obj.id = id;
                obj.progress = progress;
              } else if (
                obj.episodeName === row.episodeName &&
                obj.releaseDate === row.releaseDate
              ) {
                obj.id = id;
                obj.progress = progress;
              }
              this.props.dispatch(setAllDocuments(allDocuments));
            });
          }
        }
      }
    }
  };

  setErrorHandler = (err) => {
    this.setState({ error: err });

    this.interval = setTimeout(() => {
      if (this.state.error) this.setState({ error: null });
    }, 5000);
  };

  openModalTag = (showSelect) => {
    this.setState({
      modalTag: true,
      track: this.player.getCurrentTime(),
      showSelect: showSelect
    });
  };

  closeModalTag = () => this.setState({ modalTag: false });

  openModalCapture = (showSelect) => {
    this.setState({
      openCapture: true,
      track: this.player.getCurrentTime(),
      showSelect: showSelect
    });
  };

  closeModalCapture = () => this.setState({ openCapture: false });

  updateFlagsInPdfViewer = async () => {
    try {
      if (firebase.auth.currentUser) {
        const token = await firebase.auth.currentUser.getIdToken();

        if (this.props.pdfViewerDocumentId === this.props.playerDocument.id) {
          const {
            documentUrl,
            podcastUrl,
            tags,
            users,
            isMine,
            isShared,
            isAiFlags
          } = this.props.flagFilters;

          await this.props.dispatch(
            fetchAllFlagsByDocumentUrl(
              token,
              null,
              documentUrl,
              podcastUrl,
              tags,
              users,
              isMine,
              isShared,
              isAiFlags
            )
          );

          this.props.dispatch(createFlagFromPlayer());
        }
      }
    } catch (error) {
      // TO DO: error handling
      console.error(`Failed to fetch flags per sentence with error: ${error}`);
    }
  };

  onClickCapture = () => {
    this.openModalCapture(true);
  };

  takeHighlight = (comment) => {
    let params = {};
    if (this.props.resource !== 'notifications') {
      params = {
        trackPosition: parseInt(this.state.track, 10),
        url:
          this.props.playerDocument.url === undefined
            ? this.props.playerDocument.episode.url
            : this.props.playerDocument.url,
        imgUrl:
          this.props.playerDocument.imgUrl === undefined
            ? this.props.playerDocument.icon
            : this.props.playerDocument.imgUrl,
        tag: 'FLASH',
        podcastId: this.props.playerDocument.podcastId,
        dictation:
          comment !== undefined && comment.trim() !== '' ? comment : null,
        artistName: this.props.playerDocument.artistName,
        timestamp: moment().format('YYYY-MM-DD[T]HH:mm[Z]'),
        releaseDate: this.props.playerDocument.releaseDate,
        episodeName: this.props.playerDocument.episodeName,
        podcastName: this.props.playerDocument.podcastName
      };
    } else {
      params = {
        trackPosition: parseInt(this.state.track, 10),
        url:
          this.props.playerDocument.url === undefined
            ? this.props.playerDocument.episode.url
            : this.props.playerDocument.url,
        imgUrl:
          this.props.playerDocument.document.imgUrl === undefined
            ? this.props.playerDocument.episode.icon
            : this.props.playerDocument.imgUrl,
        tag: 'FLASH',
        podcastId: this.props.playerDocument.document.podcastId,
        dictation:
          comment !== undefined && comment.trim() !== '' ? comment : null,
        artistName: this.props.playerDocument.document.artistName,
        timestamp: moment().format('YYYY-MM-DD[T]HH:mm[Z]'),
        releaseDate: this.props.playerDocument.document.releaseDate,
        episodeName: this.props.playerDocument.document.episodeName,
        podcastName: this.props.playerDocument.document.podcastName
      };
    }

    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        const options = {
          method: 'POST',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/notes?flashnote=${true}`,
          data: params
        };

 

        axios(options)
          .then(() => {
            this.setState({
              showAlert: true,
              error: false,
              message: 'Flag Added'
            });

            setTimeout(() => {
              this.clearFlagAlert();
            }, 5000);

            /*this allowed refresh pdfViewer in case of take flag listening to document from
                    recentFlo, last5Listened, notifications  and from document tab*/
            if (
              parseInt(this.props.pdfViewerDocumentId, 10) ===
                this.props.playerDocument?.id ||
              parseInt(this.props.pdfViewerDocumentId, 10) ===
                this.props.playerDocument?.document?.id ||
              parseInt(this.props.pdfViewerDocumentId, 10) ===
                this.props.playerDocument?.documentId ||
              this.props.pdfViewerDocumentId === this.props.playerDocument?.id
            ) {
              this.updateFlagsTable(true);
            } else {
              this.updateFlagsTable(this.state.error);
            }

            this.updateFlagsInPdfViewer();
          })
          .catch(function() {
            this.setState({
              showAlert: true,
              error: true,
              message: 'Something went wrong'
            });
          });
      });
    }
  };

  saveFlagWithTag = (tag, comment) => {
    let tagToPost;

    if (tag === undefined || tag === null || tag === '') {
      this.takeHighlight(comment);

      setTimeout(() => {
        this.clearFlagAlert();
      }, 5000);
      return;
    } else {
      tagToPost = tag;

      setTimeout(() => {
        this.clearFlagAlert();
      }, 5000);
    }

    let params = {};
    if (this.props.resource !== 'notifications') {
      params = {
        trackPosition: parseInt(this.state.track, 10),
        url: this.props.playerDocument.episode.url,
        imgUrl:
          this.props.playerDocument.imgUrl === undefined
            ? this.props.playerDocument.icon
            : this.props.playerDocument.imgUrl,
        tag: tagToPost,
        podcastId: this.props.playerDocument.podcastId,
        dictation:
          comment !== undefined && comment.trim() !== '' ? comment : null,
        artistName: this.props.playerDocument.artistName,
        timestamp: moment().format('YYYY-MM-DD[T]HH:mm[Z]'),
        releaseDate: this.props.playerDocument.releaseDate,
        episodeName: this.props.playerDocument.episodeName,
        podcastName: this.props.playerDocument.podcastName
      };
    } else {
      params = {
        trackPosition: parseInt(this.state.track, 10),
        url: this.props.playerDocument.episode.url,
        imgUrl:
          this.props.playerDocument.episode.imgUrl === undefined
            ? this.props.playerDocument.episode.icon
            : this.props.playerDocument.imgUrl,
        tag: tagToPost,
        podcastId: this.props.playerDocument.podcastId,
        dictation:
          comment !== undefined && comment.trim() !== '' ? comment : null,
        artistName: this.props.playerDocument.document.artistName,
        timestamp: moment().format('YYYY-MM-DD[T]HH:mm[Z]'),
        releaseDate: this.props.playerDocument.document.releaseDate,
        episodeName: this.props.playerDocument.document.episodeName,
        podcastName: this.props.playerDocument.document.podcastName
      };
    }

    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then(async (token) => {
        try {
          await this.props.dispatch(
            addFlag(token, params, () => {
              this.setState({
                showAlert: true,
                error: false,
                message: 'Flag Added',
                addTag: false
              });
              /*this allowed refresh pdfViewer in case of take flag listening to document from
                          recentFlo, last5Listened, notifications  and from document tab*/
              if (
                parseInt(this.props.pdfViewerDocumentId, 10) ===
                  this.props.playerDocument?.id ||
                parseInt(this.props.pdfViewerDocumentId, 10) ===
                  this.props.playerDocument?.document?.id ||
                parseInt(this.props.pdfViewerDocumentId, 10) ===
                  this.props.playerDocument?.documentId ||
                this.props.pdfViewerDocumentId === this.props.playerDocument?.id
              ) {
                this.updateFlagsTable(true);
              } else {
                this.updateFlagsTable(this.state.error);
              }
            })
          );

          this.updateFlagsInPdfViewer();
        } catch (error) {
          this.setState({
            showAlert: true,
            error: true,
            message: 'Something went wrong',
            addTag: false
          });
          this.updateFlagsTable(this.state.error);
        }
      });
    }

    this.closeModalCapture();
  };

  updateFlagsTable = (option) => {
    this.props.dispatch(setFlagAdded(option));
  };

  setPlaybackRate = () => {
    const userPlaybackRate = localStorage.getItem('userPlaybackRate');
    return userPlaybackRate != null ? parseFloat(userPlaybackRate) : 1;
  };

  setTranscribeOption = () => {
    const transcribeOption = localStorage.getItem('transcribeOption');
    return transcribeOption != null ? parseInt(transcribeOption) : 1;
  };

  handleClickButtonVolume = () => {
    this.state.muted
      ? this.setState({ muted: false, volume: 0.5 })
      : this.setState({ muted: true, volume: 0 });
  };

  handleVolumeChange = (value) => {
    this.setState({ volume: value });
  };

  handleProgressChange = (event) => {
    const seekTo = parseFloat(event.target.value);
    this.player?.seekTo(seekTo);
    this.setState({ progress: seekTo });
  };

  handlePlayButtonClick = () => {
    if (this.state.playButtonState === 'pressed') return;
    this.setState({
      playButtonState: 'pressed'
    });
    setTimeout(() => {
      if (this.state.play) {
        this.handlePause();
      } else {
        this.handlePlay();
      }
    }, 100);
  };

  getCapturePlayerImage = (isActive, isSmallScreen, isPressed) => {
    if (isPressed) {
      return isSmallScreen
        ? highlightButtonSmallPressed
        : highlightButtonPressed;
    } else if (isActive) {
      return isSmallScreen ? highlightButtonSmall : highlightButton;
    } else {
      return isSmallScreen
        ? highlightButtonSmallInactive
        : highlightButtonInactive;
    }
  };

  getCapturePlayerImageSrcset = (isActive, isSmallScreen, isPressed) => {
    if (isPressed) {
      return isSmallScreen
        ? `${highlightButtonSmallPressed} 1x, ${highlightButtonSmallPressed2x} 2x, ${highlightButtonSmallPressed3x}`
        : `${highlightButtonPressed} 1x, ${highlightButtonPressed2x} 2x, ${highlightButtonPressed3x} 3x`;
    } else if (isActive) {
      return isSmallScreen
        ? `${highlightButtonSmall} 1x, ${highlightButtonSmall2x} 2x, ${highlightButtonSmall3x}`
        : `${highlightButton} 1x, ${highlightButton2x} 2x, ${highlightButton3x} 3x`;
    } else {
      return isSmallScreen
        ? `${highlightButtonSmallInactive} 1x, ${highlightButtonSmallInactive2x} 2x, ${highlightButtonSmallInactive3x}`
        : `${highlightButtonInactive} 1x, ${highlightButtonInactive2x} 2x, ${highlightButtonInactive3x} 3x`;
    }
  };

  // Clear Flag alert message
  clearFlagAlert = () => {
    this.setState({
      showAlert: false,
      showAlertAudio: false,
      message: ''
    });
  };

  render() {
    const playerDocument = this.props.playerDocument;
    const playbackRate = this.state.playbackRate;
    const enableTranscribe = this.state.play;
    const showSkipButton = this.props.showSkipButton;

    const duration = this.player?.getDuration()
      ? this.player?.getDuration()
      : 0;
    const crt = this.player?.getCurrentTime()
      ? this.player?.getCurrentTime()
      : 0;

    const displayVolume = this.state.displayVolume ? 'block' : 'none';

    if (playerDocument === '') {
      return <></>;
    }

    return (
      <>
        <div className="media-player-container">
          {playerDocument !== '' && playerDocument !== undefined && (
            <div className="player-container">
              <ReactPlayer
                ref={this.ref}
                url={
                  playerDocument.url === undefined
                    ? playerDocument.episode?.url
                    : playerDocument.url
                }
                height="45px"
                width="5px"
                playing={this.state.play}
                playbackRate={playbackRate}
                onReady={() => this.setState({ play: true })}
                onStart={this.handleStart}
                onPause={this.handlePause}
                onSeek={this.onSeek}
                onProgress={this.onProgress}
                onPlay={this.handlePlay}
                onEnded={this.onEnded}
                onError={this.handleError}
                volume={this.state.volume}
                muted={this.state.muted}
              />
              <div
                className="media-player-wrapper"
                style={{
                  maxWidth: '1200px',
                  minWidth: showSkipButton ? '560px' : '520px',
                  paddingRight: 0,
                  position: 'relative'
                }}
              >
                <div
                  className="titleOverScrubber"
                  style={{ position: 'absolute' }}
                >
                  <OverlayTrigger
                    style={{ zindex: 9999999 }}
                    trigger={['hover', 'focus']}
                    placement="bottom"
                    overlay={
                      <Popover id="popover-basic">
                        {(playerDocument.podcastName ||
                          playerDocument.podcastTitle) +
                          ' / ' +
                          playerDocument.episodeName}
                      </Popover>
                    }
                  >
                    <div
                      style={{
                        width: '60%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      {(playerDocument.podcastName ||
                        playerDocument.podcastTitle) +
                        ' / ' +
                        playerDocument.episodeName}
                    </div>
                  </OverlayTrigger>
                </div>
                <button
                  type="button"
                  onClick={this.onClickCapture}
                  className="btn-svg btn-svg-highlight"
                  disabled={!enableTranscribe}
                  onMouseDown={() =>
                    this.setState({ captureButtonPressed: true })
                  }
                  onMouseUp={() =>
                    this.setState({ captureButtonPressed: false })
                  }
                >
                  {/* <img
                    src={this.getCapturePlayerImage(
                      this.state.play,
                      this.state.isSmallScreen,
                      this.state.captureButtonPressed
                    )}
                    srcSet={this.getCapturePlayerImageSrcset(
                      this.state.play,
                      this.state.isSmallScreen,
                      this.state.captureButtonPressed
                    )}
                    width="auto"
                    height="45px"
                  /> */}
                  <div className={enableTranscribe ? 'flag-button' : 'flag-button flag-button-disabled'}>
                    <FlagIcon style={{ verticalAlign: 'text-bottom', fontSize: 19 }} />&nbsp; Flag
                  </div>
                </button>
                <div className="player-controls-container">
                  {!this.state.cantPlay && (
                    <div className="previous-next-controls">
                      {showSkipButton && (
                        <div>
                          <button
                            title="Previous document"
                            type="button"
                            className="btn-svg"
                            disabled={
                              this.props.disableSkipBackButton ? true : false
                            }
                            onClick={() => this.backward()}
                          >
                            <IconBackward
                              className="media-player-btns--stroke"
                              width="32px"
                              height="32px"
                              data-state={'active'}
                            />
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="player-controls">
                    <button
                      title="Skip Back 15 seconds"
                      type="button"
                      className="btn-svg"
                      onClick={() => this.stepBackward(15)}
                    >
                      <IconBack15
                        className="media-player-btns"
                        width="32px"
                        height="32px"
                        data-state={'active'}
                      />
                    </button>
                    <button
                      className="btn-svg"
                      onClick={() => this.handlePlayButtonClick()}
                      onMouseLeave={() =>
                        this.setState({
                          playButtonState: this.state.play
                            ? 'active'
                            : 'inactive'
                        })
                      }
                      onMouseEnter={() =>
                        this.setState({
                          playButtonState: 'active'
                        })
                      }
                      onMouseUp={() =>
                        this.setState({ playButtonState: 'active' })
                      }
                      onMouseDown={() =>
                        this.setState({ playButtonState: 'pressed' })
                      }
                    >
                      <img
                        src={getDefaultSrc(
                          this.state.play,
                          this.state.playButtonState
                        )}
                        srcSet={getImageSrcSetForCurrentState(
                          this.state.play,
                          this.state.playButtonState
                        )}
                        alt={this.state.play ? 'Pause' : 'Play'}
                        style={{
                          cursor: 'pointer',
                          width: '20px',
                          height: '20px'
                        }}
                      />
                    </button>
                    <button
                      title="Skip Ahead 15 seconds"
                      type="button"
                      className="btn-svg"
                      onClick={() => this.stepForward(15)}
                    >
                      <IconForward15
                        className="media-player-btns"
                        width="32px"
                        height="32px"
                        data-state={'active'}
                      />
                    </button>
                  </div>
                  {!this.state.cantPlay && (
                    <div className="previous-next-controls">
                      {showSkipButton && (
                        <div>
                          <button
                            title="Next document"
                            type="button"
                            className="btn-svg"
                            disabled={
                              this.props.disableSkipAheadButton ? true : false
                            }
                            onClick={() => this.forward()}
                          >
                            <IconForward
                              className="media-player-btns--stroke"
                              width="32px"
                              height="32px"
                              data-state={'active'}
                            />
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="player-number">
                    {crt !== undefined && crt !== null && !isNaN(crt)
                      ? convertSecondsToTime(crt)
                      : '00:00'}
                  </div>
                  <input
                    type="range"
                    min={0}
                    max={duration}
                    step={0.1}
                    value={this.state.progress}
                    onChange={this.handleProgressChange}
                    className="progress-bar1"
                    style={{
                      maxWidth: '95%',
                      paddingLeft: 8,
                      paddingRight: 8
                    }}
                  />
                  <div className="player-number">
                    {duration !== undefined &&
                    duration !== null &&
                    !isNaN(duration)
                      ? convertSecondsToTime(duration)
                      : '00:00'}
                  </div>
                  <div className="flex-container-volume" style={{ width: 120 }}>
                    <div
                      className="flex-container"
                      onMouseEnter={() =>
                        this.setState({ displayVolume: true })
                      }
                      onMouseLeave={() =>
                        this.setState({ displayVolume: false })
                      }
                    >
                      <button
                        type="button"
                        className="btn-svg"
                        style={{ alignItems: 'center' }}
                        onClick={this.handleClickButtonVolume}
                      >
                        {this.state.muted ? (
                          <i
                            className="fa fa-volume-off fa-2x"
                            aria-hidden="true"
                            style={{ marginLeft: '5px' }}
                          ></i>
                        ) : (
                          <VolumeButtonSvg
                            className="media-player-btns--stroke"
                            width="24px"
                            data-state={'active'}
                          />
                        )}
                      </button>
                      <div
                        className="volumemeter"
                        style={{
                          display: displayVolume,
                          alignItems: 'center',
                          marginRight: displayVolume ? '15px' : '0',
                          marginTop: '-80px'
                        }}
                      >
                        <Slider
                          vertical
                          min={0}
                          max={1}
                          value={this.state.volume}
                          marks={{ 0.0: 'Off', 1.0: 'Max' }}
                          step={0.01}
                          onChange={this.handleVolumeChange}
                        />
                      </div>
                    </div>
                    <div
                      className="flex-container"
                      onMouseEnter={() =>
                        this.setState({ showSpeedControl: true })
                      }
                      onMouseLeave={() =>
                        this.setState({ showSpeedControl: false })
                      }
                    >
                      <button
                        title="Change playback speed"
                        type="button"
                        className="btn-svg"
                      >
                        <div className="player-number player-number--playback-rate">
                          {this.state.playbackRate}x
                        </div>
                      </button>
                      {!this.state.cantPlay && this.state.showSpeedControl && (
                        <div
                          className="speedometer1"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: '-80px'
                          }}
                        >
                          <Slider
                            vertical
                            min={0.5}
                            max={2.5}
                            value={this.state.playbackRate}
                            marks={{ 0.5: '0.5x', 2.5: '2.5x' }}
                            step={0.1}
                            onChange={this.onSliderChange}
                          />
                        </div>
                      )}
                    </div>
                    <div className="flex-container">
                      <button
                        title="Close player"
                        type="button"
                        className="close-player-button align-left"
                        style={{
                          fontWeight: 100,
                          color: '#ccc',
                          fontSize: 18,
                          marginTop: -48,
                          padding: 8,
                          zIndex: 999999,
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          this.saveProgress();
                          this.props.dispatch(setPlayerDocument(''));
                          this.props.dispatch(setPlayingDocumentId(null));
                          this.setState({
                            error: false,
                            showAlert: false,
                            showAlertAudio: false,
                            message: ''
                          });
                        }}
                      >
                        x
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {!this.state.cantPlay && (
                <div className="media-player-controls">
                  <div className="speed-controls">
                    {playerDocument.isOwner && (
                      <button
                        type="button"
                        style={{ marginLeft: 5 }}
                        className="btn btn-tags button-wrapper align-left"
                        onClick={() => this.openModalTag(false)}
                      >
                        <i
                          className="fa fa-exclamation-triangle fa-lg"
                          aria-hidden="true"
                          style={{ paddingLeft: 5, paddingRight: 5 }}
                        ></i>
                      </button>
                    )}
                  </div>
                </div>
              )}
              {(this.state.showAlert || this.state.showAlertAudio) && (
                <div className="alertHighlight">
                  <Alert bsStyle={this.state.error ? 'danger' : 'success'}>
                    {this.state.message}
                  </Alert>
                </div>
              )}
            </div>
          )}
        </div>
        <CaptureWithJudgementModal
          open={this.state.openCapture}
          onClose={this.closeModalCapture}
          dialogClassName="custom-modal-size"
          track={this.state.track}
          playerDocument={this.props.playerDocument}
          //showSelect = {this.state.showSelect}
          takeHighlight={this.takeHighlight}
          saveFlagWithTag={this.saveFlagWithTag}
        />
        <ModalTag
          show={this.state.modalTag}
          onHide={this.closeModalTag}
          dialogClassName="custom-modal-size"
          track={this.state.track}
          playerDocument={this.props.playerDocument}
          parentCallback={this.showAlertFunction}
          showSelect={this.state.showSelect}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    playerDocument: store.player.playerDocument,
    disableSkipAheadButton: store.player.disableSkipAheadButton,
    disableSkipBackButton: store.player.disableSkipBackButton,
    showSkipButton: store.player.showSkipButton,
    forward: store.player.forward,
    backward: store.player.backward,
    resource: store.player.resource,
    resetProgress: store.player.resetProgress,
    fullDocuments: store.player.fullDocuments,
    allSeasons: store.player.allSeasons,
    fromPlaylistTab: store.player.fromPlaylistTab,
    allDocuments: store.player.allDocuments,
    playbackPlaylist: store.app.playbackPlaylist,
    season: store.player.season,
    onPlaylist: store.player.onPlaylist,
    sameProgress: store.player.sameProgress,
    playerFlag: store.player.playerFlag,
    pdfViewerDocumentId: store.pdf.pdfViewerDocumentId,
    isPaused: store.player.isPaused,
    flagFilters: store.pdf.flagFilters,
    feedUrl: store.player.feedUrl,
    playingDocumentId: store.app.playingDocumentId
  };
};

export default connect(mapStateToProps)(MediaPlayer);
